import axios from "axios";
import type {AxiosError, AxiosResponse} from 'axios';

const dev = false

export function getAPIUrl() {
  if (dev){
    return "https://unitoptutors.com/api"
  }

  if (typeof window === "undefined") {
    return "http://127.0.0.1:20001/api"
  }

  const hostname = window.location.hostname;
  // 本地测试
  if (hostname === "localhost" || hostname === "127.0.0.1" || hostname === '0.0.0.0') {
    return "http://127.0.0.1:20001/api"
  }
  // 内网测试
  if (/^192\.168/.test(hostname) || /^10./.test(hostname)) {
    const port = window.location.port;
    const host = port ? `${hostname}:${port}` : hostname;
    return `${window.location.protocol}//${host}:20001/api`
  }
  // 正式网络：HTTPS 默认 443 时 port 为空，不能拼出 host:/api
  const port = window.location.port;
  const host = port ? `${hostname}:${port}` : hostname;
  return `${window.location.protocol}//${host}/api`
}

export function isLocal() : boolean{
  const hostname = window.location.hostname;
  // 本地测试
  if (hostname === "localhost" || hostname === "127.0.0.1" || hostname === '0.0.0.0') {
    return true
  }
  return /^192\.168/.test(hostname) || /^10./.test(hostname);
}


export type  ErrorMsg = {
  code: number,
  http_code: number;
  message: string,
  level: string;
  ref: string;
  line: string;
  data: never;
}

export const Request = axios.create({
  baseURL: getAPIUrl(),
  timeout: 900000,
});
Request.defaults.timeout = 900000;

Request.interceptors.response.use(
  (response: AxiosResponse) => {
    return response;
  },
  (error: AxiosError) => {
    const resp = error.response
    // const { showToast } = useToast();

    if (resp === undefined) {
      return Promise.reject(error);
    }

    const msg = resp.data as ErrorMsg

    if (msg !== undefined && msg.message !== undefined) {
      console.log(msg)
      // message.error(msg.message).then()
      // WarnToast(`错误: ${msg.message} (${msg.code})`)
      // alert(`错误: ${msg.message} (${msg.code})`)
      // showToast({ title: "错误", description: `错误: ${msg.message} (${msg.code})` })
    }
    return Promise.reject(error);
  },
)
